const headerBis = document.querySelector('#menu-navigation-principale');
const toolBar = document.querySelector('.tools-sidebar').cloneNode(true);

const responsive = () => {
  if (window.innerWidth <= 992) {
    if (headerBis.contains(toolBar)) return;
    toolBar.classList.add('tools-sidebar--responsive');
    headerBis.appendChild(toolBar);
  }
};

window.addEventListener('resize', responsive());
responsive();
